import { getSlimLogoPath } from './slimLogo';
import inventoryAPI from '../services/inventoryApi';
import { openBlob } from './reportBlob';

function nowGeneratedAt() {
  return new Date().toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true,
  });
}

export async function openGRNReport(grn, company = {}) {
  if (!grn) return;
  const logoUrl = window.location.origin + getSlimLogoPath();
  const watermarkUrl = window.location.origin + '/SLIM%20LOGO%20BLACK.png';
  try {
    const generatedAt = nowGeneratedAt();
    const res = await inventoryAPI.getGRNReport(grn._id || grn.id, {
      company, logoUrl, watermarkUrl, generatedAt, userNameMap: {},
    });
    openBlob(res.base64);
  } catch (err) {
    console.error('[openGRNReport] failed:', err);
  }
}

export async function openSupplierReturnNoteReport(note, company = {}) {
  if (!note) return;
  const logoUrl = window.location.origin + getSlimLogoPath();
  const watermarkUrl = window.location.origin + '/SLIM%20LOGO%20BLACK.png';
  try {
    const generatedAt = nowGeneratedAt();
    const res = await inventoryAPI.getSupplierReturnNoteReport(note._id || note.id, {
      company, logoUrl, watermarkUrl, generatedAt, userNameMap: {},
    });
    openBlob(res.base64);
  } catch (err) {
    console.error('[openSupplierReturnNoteReport] failed:', err);
  }
}

export async function openDebitNoteReport(note, company = {}) {
  if (!note) return;
  const logoUrl = window.location.origin + getSlimLogoPath();
  const watermarkUrl = window.location.origin + '/SLIM%20LOGO%20BLACK.png';
  try {
    const generatedAt = nowGeneratedAt();
    const res = await inventoryAPI.getDebitNoteReport(note._id || note.id, {
      company, logoUrl, watermarkUrl, generatedAt, userNameMap: {},
    });
    openBlob(res.base64);
  } catch (err) {
    console.error('[openDebitNoteReport] failed:', err);
  }
}

export async function openPurchaseOrderReport(po, company = {}) {
  if (!po) return;
  const logoUrl = window.location.origin + getSlimLogoPath();
  const watermarkUrl = window.location.origin + '/SLIM%20LOGO%20BLACK.png';
  try {
    const generatedAt = nowGeneratedAt();
    const res = await inventoryAPI.getPurchaseOrderReport(po._id || po.id, {
      company, logoUrl, watermarkUrl, generatedAt, userNameMap: {},
    });
    openBlob(res.base64);
  } catch (err) {
    console.error('[openPurchaseOrderReport] failed:', err);
  }
}

export async function openPurchaseRequestReport(pr, company = {}) {
  if (!pr) return;
  const logoUrl = window.location.origin + getSlimLogoPath();
  const watermarkUrl = window.location.origin + '/SLIM%20LOGO%20BLACK.png';
  try {
    const generatedAt = nowGeneratedAt();
    const res = await inventoryAPI.getPurchaseRequestReport(pr._id || pr.id, {
      company, logoUrl, watermarkUrl, generatedAt, userNameMap: {},
    });
    openBlob(res.base64);
  } catch (err) {
    console.error('[openPurchaseRequestReport] failed:', err);
  }
}

export async function openSupplierPaymentReport(payment, company = {}) {
  if (!payment) return;
  const logoUrl = window.location.origin + getSlimLogoPath();
  const watermarkUrl = window.location.origin + '/SLIM%20LOGO%20BLACK.png';
  try {
    const generatedAt = nowGeneratedAt();
    const res = await inventoryAPI.getSupplierPaymentReport(payment._id || payment.id, {
      company, logoUrl, watermarkUrl, generatedAt, userNameMap: {},
    });
    openBlob(res.base64);
  } catch (err) {
    console.error('[openSupplierPaymentReport] failed:', err);
  }
}
